import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { PriceDisplay } from '../price/PriceDisplay';
import { PricePerMonth } from '../price/PricePerMonth';

// Prices from https://docs.google.com/document/d/1Coy198hfnuLN3p0UgXLWb9vwI0omDEy8lb6lx-__cQo/edit?tab=t.0#heading=h.ww9cpi90mt1e
import { jsx as _jsx } from "react/jsx-runtime";
const OLD_DISCOUNTED_ANNUAL_PRICES = {
  USD: 15,
  EUR: 15,
  GBP: 14,
  AUD: 22,
  JPY: 1800,
  SGD: 21,
  CAD: 20,
  COP: 45000,
  INR: 1253
};
const OLD_DISCOUNTED_MONTHLY_PRICES = {
  USD: 20,
  EUR: 20,
  GBP: 18,
  AUD: 29,
  JPY: 2400,
  SGD: 28,
  CAD: 26,
  COP: 60000,
  INR: 1670
};
export const StarterPromotion2025Banner = ({
  currencyCode,
  annualPrice,
  monthlyPrice
}) => {
  const seleniumId = 'starter-promotion-2025-banner';
  return /*#__PURE__*/_jsx(Alert, {
    "data-test-id": seleniumId,
    type: "info",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "starterPromotion2025Banner.title"
    }),
    inlineSize: "100%",
    children: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "starterPromotion2025Banner.description",
      options: {
        newAnnualPrice: /*#__PURE__*/_jsx(PricePerMonth, {
          price: annualPrice,
          showPricePerMonthPerSeat: false,
          currencyCode: currencyCode,
          seleniumId: `${seleniumId}-new-annual-price`
        }),
        oldAnnualPrice: /*#__PURE__*/_jsx(PriceDisplay, {
          price: OLD_DISCOUNTED_ANNUAL_PRICES[currencyCode],
          currencyCode: currencyCode,
          dataSelenium: `${seleniumId}-old-annual-price`
        }),
        newMonthlyPrice: /*#__PURE__*/_jsx(PricePerMonth, {
          price: monthlyPrice,
          showPricePerMonthPerSeat: false,
          currencyCode: currencyCode,
          seleniumId: `${seleniumId}-new-monthly-price`
        }),
        oldMonthlyPrice: /*#__PURE__*/_jsx(PriceDisplay, {
          price: OLD_DISCOUNTED_MONTHLY_PRICES[currencyCode],
          currencyCode: currencyCode,
          dataSelenium: `${seleniumId}-old-monthly-price`
        })
      }
    })
  });
};